document.addEventListener("DOMContentLoaded", function () {
	const accordions = document.querySelectorAll(".accordion");

	accordions.forEach(function (accordion, accIndex) {
		const items = accordion.querySelectorAll(".accordion__item");

		items.forEach(function (item, index) {
			const button = item.querySelector(".accordion__button");
			const panel = item.querySelector(".accordion__info");

			// Eindeutige IDs
			const btnId = `accordion-${accIndex}-btn-${index}`;
			const panelId = `accordion-${accIndex}-panel-${index}`;

			// Button ARIA
			button.setAttribute("id", btnId);
			button.setAttribute("aria-controls", panelId);
			button.setAttribute("aria-expanded", item.classList.contains("accordion__item--show") ? "true" : "false");

			// Panel ARIA
			panel.setAttribute("id", panelId);
			panel.setAttribute("role", "region");
			panel.setAttribute("aria-labelledby", btnId);

			// Click event
			button.addEventListener("click", function () {
				const isOpen = item.classList.contains("accordion__item--show");

				// Toggle this item
				item.classList.toggle("accordion__item--show");
				button.setAttribute("aria-expanded", !isOpen);

				// Close other items in same accordion
				items.forEach(function (otherItem) {
					if (otherItem !== item) {
						otherItem.classList.remove("accordion__item--show");
						const otherButton = otherItem.querySelector(".accordion__button");
						otherButton.setAttribute("aria-expanded", "false");
					}
				});
			});
		});
	});
});
